// extracted by mini-css-extract-plugin
module.exports = {"notificationDot":"NotificationDot_notificationDot__WHgIV","small":"NotificationDot_small__K_ISE","medium":"NotificationDot_medium__IuvvY"};